<template>
  <h3>{{title}}</h3>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'VerticalMenuHeaderWidget',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>

  h3 {
    margin-top:10px;
    margin-bottom:40px;
    font-size:20px;
  }

</style>
